import { PropsWithChildren } from 'react';
import { Box } from 'reflexbox';

import { Label } from '@treams/treams-ui/common/Text';

export default function Property(props: PropsWithChildren<{ title: string }>) {
	return (
		<>
			<Box mb={1}>
				<Label>{props.title}</Label>
			</Box>
			{props.children}
			<Box my={3} />
		</>
	);
}
